import React from 'react';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';

const MapwiseBi = () => {
  // Sample state-wise data
  const stateWiseData = [
    { state: 'Maharashtra', transactions: 12500, revenue: '₹45,67,890', growth: '+15.2%', growthType: 'positive' },
    { state: 'Delhi', transactions: 9800, revenue: '₹38,45,670', growth: '+12.8%', growthType: 'positive' },
    { state: 'Karnataka', transactions: 8700, revenue: '₹32,56,780', growth: '+10.5%', growthType: 'positive' },
    { state: 'Tamil Nadu', transactions: 7600, revenue: '₹28,90,450', growth: '+8.3%', growthType: 'positive' },
    { state: 'Gujarat', transactions: 6900, revenue: '₹25,78,900', growth: '-2.1%', growthType: 'negative' },
    { state: 'Rajasthan', transactions: 5400, revenue: '₹19,87,650', growth: '+6.7%', growthType: 'positive' },
    { state: 'Uttar Pradesh', transactions: 4800, revenue: '₹17,65,430', growth: '+5.4%', growthType: 'positive' },
    { state: 'West Bengal', transactions: 4200, revenue: '₹15,43,210', growth: '-1.8%', growthType: 'negative' }
  ];

  const topRegions = [
    { region: 'Western Region', value: '42%', color: 'primary' },
    { region: 'Southern Region', value: '28%', color: 'success' },
    { region: 'Northern Region', value: '20%', color: 'info' },
    { region: 'Eastern Region', value: '10%', color: 'warning' }
  ];

  return (
    <Container fluid className="">
      {/* Page Header */}
      <div className="mb-4">
        <h4 className="mb-1" style={{ color: '#1e293b', fontWeight: '700', fontSize: '1.5rem' }}>
          Mapwise Business Intelligence
        </h4>
        <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
          Geographic distribution and regional performance analytics
        </p>
      </div>

      {/* Regional Distribution */}
      <Row className="mb-4">
        <Col lg={8} className="mb-4">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <h5 className="mb-4" style={{ fontWeight: '700', color: '#1e293b' }}>
                India Map - Transaction Distribution
              </h5>
              <div className="text-center py-5">
                <i className="bi bi-map fs-1 text-muted mb-3 d-block"></i>
                <p className="text-muted">Interactive India map will be displayed here</p>
                <small className="text-muted">Showing state-wise transaction density</small>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} className="mb-4">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <h5 className="mb-4" style={{ fontWeight: '700', color: '#1e293b' }}>
                Regional Performance
              </h5>
              {topRegions.map((region, index) => (
                <div key={index} className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: '0.875rem', fontWeight: '600' }}>
                      {region.region}
                    </span>
                    <span className={`badge bg-${region.color}`}>
                      {region.value}
                    </span>
                  </div>
                  <div className="progress" style={{ height: '8px' }}>
                    <div 
                      className={`progress-bar bg-${region.color}`}
                      style={{ width: region.value }}
                    ></div>
                  </div>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* State-wise Performance Table */}
      <Row>
        <Col lg={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h5 className="mb-4" style={{ fontWeight: '700', color: '#1e293b' }}>
                State-wise Performance
              </h5>
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                    <tr>
                      <th>Rank</th>
                      <th>State</th>
                      <th>Total Transactions</th>
                      <th>Revenue</th>
                      <th>Growth</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stateWiseData.map((state, index) => (
                      <tr key={index}>
                        <td>
                          <span className="badge bg-secondary">{index + 1}</span>
                        </td>
                        <td style={{ fontWeight: '600' }}>{state.state}</td>
                        <td>{state.transactions.toLocaleString()}</td>
                        <td style={{ fontWeight: '600', color: '#10b981' }}>{state.revenue}</td>
                        <td>
                          <span className={`text-${state.growthType === 'positive' ? 'success' : 'danger'}`}>
                            {state.growth}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MapwiseBi;

